import { render, staticRenderFns } from "./Tele2CardHeader.vue?vue&type=template&id=6b364ea7&scoped=true&"
import script from "./Tele2CardHeader.vue?vue&type=script&lang=js&"
export * from "./Tele2CardHeader.vue?vue&type=script&lang=js&"
import style0 from "./Tele2CardHeader.vue?vue&type=style&index=0&id=6b364ea7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b364ea7",
  null
  
)

export default component.exports